export const FLOOR_CONDITION = 'Floor'
export const FLOOR_CONDITION_PROFILE = ['Před rekonstrukcí', 'Ve špatném stavu']

export const getValuationConditionProfile = (condition) => (condition === FLOOR_CONDITION ? FLOOR_CONDITION_PROFILE : null)

export const getCalculationCondition = (condition) => (condition === FLOOR_CONDITION ? FLOOR_CONDITION_PROFILE[0] : condition)
